import { getCurrentInstance, onBeforeMount, ref, Ref } from 'vue'

export function useOutsideOverlay(): {
  overlayElementId: string
  hasOverlayElement: Ref<boolean>
} {
  // state
  const hasOverlayElement = ref(false)

  // data
  const overlayElementId = 'outside-overlay'

  // init
  onBeforeMount(() => {
    const instance = getCurrentInstance()
    const appRootElement = instance?.proxy?.$root?.$el?.parentNode

    // if appRootElement is undefined, then we are in a test environment (storybook)
    if (!appRootElement) return

    if (appRootElement.querySelector(`#${overlayElementId}`)) {
      hasOverlayElement.value = true
      return
    }

    const popoverTeleportElement = document.createElement('div')
    popoverTeleportElement.id = overlayElementId
    appRootElement.prepend(popoverTeleportElement)

    hasOverlayElement.value = true
  })

  return {
    overlayElementId,
    hasOverlayElement,
  }
}
